import { onError } from 'apollo-link-error';

export const errorLink = onError(() => {
  // if (networkError) window.alert('Network error?');
});
